import script from "./loaderGenerateConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./loaderGenerateConfig.vue?vue&type=script&lang=ts&setup=true"

import "./loaderGenerateConfig.vue?vue&type=style&index=0&id=54b5077e&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b5077e"]])

export default __exports__